// ─── Manifest immagini (generato da parse-catalog.js) ────────────────────────
// Le URL sono path statici serviti direttamente da public/ senza passare
// per il bundle di Vite. Rigenera con: node parse-catalog.js
import manifest from './catalogManifest.json';

// ─── Contesto SEO per categoria brand (usato per alt text immagini) ──────────
export const CATEGORY_CONTEXT = {
  Luxury:      'occhiali di lusso',
  Fashion:     'occhiali moda',
  Sport:       'occhiali sportivi',
  Kids:        'occhiali bambini',
  Lifestyle:   'occhiali',
  Innovazione: 'occhiali tecnologici',
};

// ─── Funzione pubblica: ottieni immagini per brand ────────────────────────────

export function getCatalogImages(brandSlug) {
  return manifest[brandSlug] ?? {};
}

// ─── Nomi prodotto personalizzati (sovrascrivono il nome auto-generato dallo slug file) ──
const PRODUCT_NAME_OVERRIDES = {
  dsquared: {
    '107888-3yg':               'Dsquared2 Vista 107888',
    '109382080700':             'Dsquared2 Sole 109382',
    '11018002w800':             'Dsquared2 Sole 110180',
    '20789800nz08':             'Dsquared2 Sole 207898',
    'd2-0166-109382-807':       'Dsquared2 D2 0166',
    'd2-0192-s':                'Dsquared2 D2 0192/S',
    'd2-0197-s-208775-086579k': 'Dsquared2 D2 0197/S',
    'd2-0200-g-ans':            'Dsquared2 D2 0200/G',
    'd2-0202-g-s':              'Dsquared2 D2 0202/G/S',
    'd2-0203':                  'Dsquared2 D2 0203',
    'd2-0204':                  'Dsquared2 D2 0204',
    'd2-0205':                  'Dsquared2 D2 0205',
    'icon-0029-s':              'Dsquared2 Icon 0029/S',
    'icon-0030-s':              'Dsquared2 Icon 0030/S',
  },
};

export function getProductDisplayName(brandSlug, productKey) {
  return PRODUCT_NAME_OVERRIDES[brandSlug]?.[productKey] ?? null;
}

// ─── Metadati brand ───────────────────────────────────────────────────────────

export const brandsMeta = [
  {
    slug: 'blackfin',
    name: 'Blackfin',
    category: 'Luxury',
    description:
      'Nata in Val Gardena nel 1999, Blackfin realizza montature in titanio ultra-leggero prodotte interamente in Italia. Ogni occhiale unisce ingegneria di precisione e design alpino, pesando spesso meno di 10 grammi. La collezione disponibile da Ottica Bellodi include modelli vista e sole per uno stile raffinato e discreto.',
  },
  {
    slug: 'calvin-klein',
    name: 'Calvin Klein',
    category: 'Fashion',
    description:
      'Calvin Klein Eyewear esprime il minimalismo americano che ha reso celebre il brand newyorkese. Linee pulite, proporzioni equilibrate e materiali premium caratterizzano ogni montatura, pensata per chi cerca eleganza senza eccessi. Disponibile da Ottica Bellodi a Torino.',
  },
  {
    slug: 'carrera',
    name: 'Carrera',
    category: 'Sport',
    description:
      'Fondata nel 1956 in Austria, Carrera ha vestito piloti, sciatori e icone del motorsport per decenni. Le montature combinano spirito sportivo e design audace, con tecnologie costruttive avanzate per garantire resistenza e comfort nelle condizioni più estreme.',
  },
  {
    slug: 'carrera-ducati',
    name: 'Carrera × Ducati',
    category: 'Sport',
    description:
      'La collaborazione tra Carrera e Ducati porta sull\'eyewear l\'estetica racing del marchio motociclistico italiano. Design aerodinamico, colorazioni racing e dettagli tecnici ispirati alle moto da corsa: una collezione per chi vive la velocità come stile di vita.',
  },
  {
    slug: 'cf',
    name: 'Carolina Herrera',
    category: 'Fashion',
    description:
      'CF by Carolina Herrera rappresenta l\'eleganza latina con tocchi di modernità newyorkese. Forme sofisticate, acetati pregiati e dettagli metallici dorati definiscono una collezione per la donna contemporanea che non rinuncia al glamour nel quotidiano.',
  },
  {
    slug: 'david-beckham',
    name: 'David Beckham',
    category: 'Fashion',
    description:
      'La linea eyewear di David Beckham riflette lo stile personale dell\'icona britannica: classico britannico con tocchi contemporanei. Montature squadrate, acetati premium e finiture metalliche impeccabili, pensate per un uomo che cura ogni dettaglio del suo look.',
  },
  {
    slug: 'dsquared',
    name: 'Dsquared2',
    category: 'Fashion',
    description:
      'Dsquared2 porta nell\'eyewear l\'estetica bold e irriverente dei gemelli Dean e Dan Caten. Montature dal carattere deciso, forme squadrate e dettagli metallici a contrasto per chi ama un look contemporaneo e sicuro di sé, tra vista e sole.',
  },
  {
    slug: 'etnia-barcelona',
    name: 'Etnia Barcelona',
    category: 'Lifestyle',
    description:
      'Fondata a Barcellona nel 2001, Etnia è sinonimo di colore, artigianalità e rispetto per la cultura. Ogni collezione si ispira a città e culture del mondo, realizzata in acetato di altissima qualità tinto a mano. Da Ottica Bellodi trovi una selezione ampia di modelli uomo, donna e unisex.',
  },
  {
    slug: 'etro',
    name: 'Etro',
    category: 'Luxury',
    description:
      'Etro porta nell\'eyewear la sua firma inconfondibile: il paisley, i tessuti preziosi, i colori saturi. Le montature sono oggetti di moda raffinati, arricchiti da dettagli ispirati all\'heritage tessile milanese del brand fondato nel 1968.',
  },
  {
    slug: 'hugo-boss',
    name: 'Hugo Boss',
    category: 'Fashion',
    description:
      'Hugo Boss Eyewear interpreta il guardaroba maschile con rigore tedesco e senso estetico contemporaneo. Montature dal design preciso e costruzione robusta, adatte tanto all\'ambiente professionale quanto al tempo libero. Una scelta affidabile per chi cerca qualità senza compromessi.',
  },
  {
    slug: 'hugo-hg',
    name: 'HUGO',
    category: 'Fashion',
    description:
      'HUGO, la linea giovane di Hugo Boss, porta nell\'eyewear un design più audace e contemporaneo. Forme geometriche, colorazioni inaspettate e strutture innovative per chi vuole distinguersi con personalità e non seguire semplicemente le tendenze.',
  },
  {
    slug: 'jimmy-choo',
    name: 'Jimmy Choo',
    category: 'Luxury',
    description:
      'Jimmy Choo trasferisce nell\'eyewear il lusso glamour che ha reso celebre il marchio nel mondo della moda. Cristalli, dettagli metallici preziosi e silhouette femminili sofisticate: ogni montatura è un accessorio completo che completa un look d\'alta moda.',
  },
  {
    slug: 'kate-spade',
    name: 'Kate Spade',
    category: 'Fashion',
    description:
      'Kate Spade New York porta nell\'eyewear il suo spirito giocoso, colorato e positivo. Forme cat-eye, stampe audaci, colori vivaci e tocchi d\'oro caratterizzano una collezione pensata per la donna che ama esprimersi con ottimismo e stile.',
  },
  {
    slug: 'lacoste',
    name: 'Lacoste',
    category: 'Sport',
    description:
      'Lacoste incarna il perfetto equilibrio tra spirito sportivo e eleganza prêt-à-porter. Nata sul campo da tennis nel 1933, la maison francese propone montature fresche, colorate e di qualità, con il coccodrillo verde come simbolo di uno stile di vita attivo e raffinato.',
  },
  {
    slug: 'liu-jo',
    name: 'Liu Jo',
    category: 'Fashion',
    description:
      'Liu Jo è il brand italiano che ha saputo democratizzare la femminilità glamour. Le montature della collezione eyewear riprendono i materiali pregiati, le decorazioni floreali e le silhouette sensuali che hanno reso il brand di Carpi amato in tutto il mondo.',
  },
  {
    slug: 'marc-jacobs',
    name: 'Marc Jacobs',
    category: 'Fashion',
    description:
      'Marc Jacobs porta nell\'eyewear la sua visione eclettica della moda: vintage e moderno, classico e sovversivo. Forme seventies rivisitate, lettere bold in metallo e una palette cromatica che spazia dal neutro all\'audace per un eyewear con personalità.',
  },
  {
    slug: 'moschino-love',
    name: 'Love Moschino',
    category: 'Fashion',
    description:
      'Love Moschino esprime l\'ironia e la creatività del brand romano in chiave accessibile. Montature con dettagli pop, loghi a vista e un approccio ludico alla moda che rispecchia lo spirito ribelle e romantico che ha sempre contraddistinto Moschino.',
  },
  {
    slug: 'pierre-cardin',
    name: 'Pierre Cardin',
    category: 'Fashion',
    description:
      'Pierre Cardin è stato un pioniere del design futurista e della democratizzazione della haute couture. Le sue montature portano il DNA futurista del brand francese: linee architettoniche, forme scultoree e un tocco di eleganza senza tempo.',
  },
  {
    slug: 'polaroid',
    name: 'Polaroid',
    category: 'Lifestyle',
    description:
      'Polaroid è sinonimo di lenti polarizzate di qualità accessibile. Con oltre 75 anni di expertise nella tecnologia delle lenti, Polaroid offre occhiali da sole che eliminano il riverbero e migliorano i contrasti, per una visione nitida in ogni condizione di luce. Ampia selezione da Ottica Bellodi.',
  },
  {
    slug: 'polaroid-ancillaries',
    name: 'Polaroid Ancillaries',
    category: 'Lifestyle',
    description:
      'Gli accessori della linea Polaroid Ancillaries completano l\'esperienza eyewear con clip magnetiche, astucci premium e complementi pensati per chi usa occhiali da vista e vuole la protezione solare senza dover cambiare montatura.',
  },
  {
    slug: 'polaroid-bimbo',
    name: 'Polaroid Bimbo',
    category: 'Kids',
    description:
      'Polaroid Bimbo porta la qualità delle lenti polarizzate anche ai più piccoli. Montature resistenti progettate per i bambini, con lenti che proteggono gli occhi ancora in sviluppo dai raggi UV e dal riverbero. Sicuri, colorati e pratici.',
  },
  {
    slug: 'polaroid-kids',
    name: 'Polaroid Kids',
    category: 'Kids',
    description:
      'La collezione Polaroid Kids unisce resistenza, sicurezza e stile per i bambini. Montature flessibili in materiali infrangibili, lenti con protezione UV 400 e design vivaci che i bambini amano indossare. Disponibili da Ottica Bellodi per i più piccoli dai 3 anni.',
  },
  {
    slug: 'polaroid-sole',
    name: 'Polaroid Sole',
    category: 'Sport',
    description:
      'Polaroid Sole è la linea dedicata agli occhiali da sole con tecnologia polarizzata avanzata. Forme aviator, wayfarer e sport combinate con le rinominate lenti Polaroid per una protezione visiva superiore durante le attività all\'aperto.',
  },
  {
    slug: 'polaroid-sport',
    name: 'Polaroid Sport',
    category: 'Sport',
    description:
      'Polaroid Sport è pensata per gli sportivi che non vogliono rinunciare alla qualità ottica. Montature avvolgenti, lenti polarizzate ad alto contrasto e materiali ultraleggeri per ciclismo, running, vela e qualsiasi attività outdoor.',
  },
  {
    slug: 'safilo',
    name: 'Safilo',
    category: 'Fashion',
    description:
      'Safilo è uno dei principali gruppi eyewear mondiali, fondato a Padova nel 1934. La collezione proprio brand propone montature di qualità con un design italiano classico e contemporaneo, artigianalmente prodotte nello stabilimento di Longarone, cuore della tradizione ottica italiana.',
  },
  {
    slug: 'seventh-street',
    name: 'Seventh Street',
    category: 'Lifestyle',
    description:
      'Seventh Street porta sul mercato eyewear accessibile e alla moda ispirato allo streetwear urbano. Forme contemporanee, colorazioni di tendenza e materiali di qualità per chi vuole un look curato senza una spesa eccessiva. Perfetto per i giovani.',
  },
  {
    slug: 'silhouette',
    name: 'Silhouette',
    category: 'Luxury',
    description:
      'Silhouette è il marchio austriaco pioniere degli occhiali ultra-leggeri e senza viti. La sua iconica montatura Titan Minimal Art pesa meno di 2 grammi: un prodigio ingegneristico realizzato a Vienna dal 1964. Per chi esige il massimo in termini di comfort e invisibilità.',
  },
  {
    slug: 'tommy-hilfiger',
    name: 'Tommy Hilfiger',
    category: 'Fashion',
    description:
      'Tommy Hilfiger Eyewear porta i classici americani preppy nell\'ottico. Colori dell\'americana (rosso, bianco, blu), dettagli a contrasto e costruzione solida caratterizzano montature che si adattano perfettamente a uno stile casual chic di ogni giorno.',
  },
  {
    slug: 'bragi',
    name: 'BRAGi3D',
    category: 'Innovazione',
    description:
      'BRAGi3D è l\'esclusiva tecnologia di Ottica Bellodi per la realizzazione di montature stampate in 3D su misura. Ogni occhiale nasce da una scansione digitale del viso del cliente e viene prodotto con tecnologia SLS in nylon PA12, garantendo una vestibilità perfetta impossibile da ottenere con metodi tradizionali. Disponibile esclusivamente da Ottica Bellodi a Torino.',
  },
];

// ─── Utility ──────────────────────────────────────────────────────────────────

export function getAllBrands() {
  return brandsMeta;
}

export function getBrandBySlug(slug) {
  return brandsMeta.find((b) => b.slug === slug) ?? null;
}
